import { Skeleton, Stack } from "@mui/material";
import { useEffect } from "react";

import { isMobile } from "react-device-detect";
import { useSessionContext } from "../../../contexts/SessionContext";
import { DeviceIDPatch } from "../../../services/scim/profile/DeviceIDPatch";
// Componente unificado que substitui MobilePatient e WebPatient (mobile-first)
import { PatientDash } from "./PatientDash/PatientDash";

interface ISelectOption {
  label: string;
  value: string;
}

export interface IFormInput {
  healthcareService: ISelectOption | undefined;
  organization: ISelectOption | undefined;
  practitioner: ISelectOption | undefined;
}

export function PatientDashboard() {
  const { inviteDialog, user, fetchUser } = useSessionContext();

  // Login web sem tokenMobile na URL grava a string "undefined" no localStorage.
  // Tratar como "sem token": senão o PATCH + fetchUser rodam a cada montagem e,
  // como fetchUser liga o loading da sessão (Home desmonta o dashboard), viram loop.
  const rawTokenMobile = localStorage.getItem("device_id");
  const tokenMobile =
    rawTokenMobile && rawTokenMobile !== "undefined" && rawTokenMobile !== "null"
      ? rawTokenMobile
      : undefined;

  const updateDeviceIdMobile = async () => {
    if (user?.tokenFirebaseMobile === undefined && isMobile) {
      try {
        await DeviceIDPatch({
          idUser: user?.id,
          operation: "add",
          pathName:
            "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User:deviceIDMobile",
          valueField: tokenMobile,
        });
        // Só recarrega o usuário se o PATCH gravou: com falha, o token continua
        // diferente e o fetchUser (que desmonta o dashboard) entraria em loop.
        fetchUser();
      } catch (err) {
        console.log("err", err);
      }
      return;
    }
    if (tokenMobile !== user?.tokenFirebaseMobile) {
      try {
        await DeviceIDPatch({
          idUser: user?.id,
          operation: "replace",
          pathName:
            "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User:deviceIDMobile",
          valueField: tokenMobile,
        });
        fetchUser();
      } catch (err) {
        console.log("err", err);
      }
      return;
    }
  };

  useEffect(() => {
    if (user?.tokenFirebaseMobile === tokenMobile || tokenMobile === undefined)
      return;
    else {
      updateDeviceIdMobile();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenMobile && user?.tokenFirebaseMobile]);

  if (inviteDialog) {
    return <Skeleton variant="rectangular" width="100%" height="15vh" />;
  }

  return (
    <>
      <Stack width="100%" height="fit-content" gap={1}>
        {/* PatientDash lida internamente com o layout mobile e desktop */}
        <PatientDash />
      </Stack>
    </>
  );
}
